module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pulmonology1.fc570ba8.png";